export const translationsEN = {
  // ─── Navigation ────────────────────────────────────────────────────────────
  'nav.home': 'Home',
  'nav.matching': 'Matching',
  'nav.search': 'Search',
  'nav.projects': 'Projects',
  'nav.marketplace': 'Marketplace',
  'nav.dashboard': 'Dashboard',
  'nav.messages': 'Messages',
  'nav.profile': 'Profile',
  'nav.logout': 'Log out',
  'nav.settings': 'Settings',
  'nav.notifications': 'Notifications',

  // ─── Common ────────────────────────────────────────────────────────────────
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.close': 'Close',
  'common.submit': 'Submit',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.view': 'View',
  'common.download': 'Download',
  'common.upload': 'Upload',
  'common.send': 'Send',
  'common.apply': 'Apply',
  'common.accept': 'Accept',
  'common.reject': 'Reject',
  'common.confirm': 'Confirm',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.create': 'Create',
  'common.update': 'Update',
  'common.remove': 'Remove',
  'common.share': 'Share',
  'common.copied': 'Copied!',
  'common.noData': 'No data available',
  'common.errorSaving': 'Failed to save changes',
  'common.errorLoading': 'Failed to load data',
  'common.viewAll': 'View all',
  'common.seeMore': 'See more',
  'common.seeLess': 'See less',
  'common.optional': 'Optional',
  'common.required': 'Required',
  'common.retry': 'Retry',

  // ─── Auth ──────────────────────────────────────────────────────────────────
  'auth.login': 'Log In',
  'auth.register': 'Sign Up',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Confirm Password',
  'auth.forgotPassword': 'Forgot password?',
  'auth.noAccount': "Don't have an account?",
  'auth.hasAccount': 'Already have an account?',
  'auth.loginError': 'Invalid email or password',
  'auth.registerError': 'Registration failed',
  'auth.passwordMismatch': 'Passwords do not match',
  'auth.emailRequired': 'Email is required',
  'auth.passwordRequired': 'Password is required',
  'auth.loginSuccess': 'Successfully logged in',
  'auth.registerSuccess': 'Account created successfully',
  'auth.logoutSuccess': 'Successfully logged out',
  'auth.emailPlaceholder': 'your@email.com',
  'auth.passwordPlaceholder': 'At least 8 characters',
  'auth.fullName': 'Full Name',
  'auth.fullNamePlaceholder': 'Your full name',
  'auth.creatingAccount': 'Creating account...',
  'auth.loggingIn': 'Logging in...',
  'auth.registerConfirmRequired': 'Check your email to confirm your account',
  'auth.registerConfirmHint': 'We sent a verification link to {email}',
  'auth.welcomeTitle': 'Welcome to Resuena',
  'auth.welcomeSubtitle': 'Connect with musicians around the world',
  'auth.registerTitle': 'Create your account',
  'auth.registerSubtitle': 'Join the musical community',

  // ─── Dashboard ─────────────────────────────────────────────────────────────
  'dashboard.welcome': 'Welcome back',
  'dashboard.subtitle': 'Here is an overview of your activity today.',
  'dashboard.quickActions': 'Quick Actions',
  'dashboard.recentActivity': 'Recent Activity',
  'dashboard.upcomingEvents': 'Upcoming Events',
  'dashboard.nearbyMusicians': 'Nearby Musicians',
  'dashboard.applications': 'Applications',
  'dashboard.bookings': 'Bookings',
  'dashboard.findMusicians': 'Find Musicians',
  'dashboard.createProject': 'Create Project',
  'dashboard.postGig': 'Post a Gig',
  'dashboard.viewProfile': 'View Profile',
  'dashboard.noActivity': 'No recent activity',
  'dashboard.noEvents': 'No upcoming events',
  'dashboard.totalWorkload': 'Total Workload',
  'dashboard.completedTasks': 'Completed',
  'dashboard.pendingTasks': 'Pending',
  'dashboard.productivity': 'Productivity',
  'dashboard.tasks': 'tasks',
  'dashboard.high': 'High',
  'dashboard.medium': 'Medium',
  'dashboard.low': 'Low',
  'dashboard.priorityOverview': 'Priority Overview',
  'dashboard.viewAllActivities': 'View All Activities',
  'dashboard.performance': 'Performance',
  'dashboard.weeklyGoal': 'Weekly Goal',
  'dashboard.achievements': 'Achievements',
  'dashboard.collaborations': 'Collaborations',
  'dashboard.activeProjects': 'Active Projects',
  'dashboard.pendingMessages': 'Unread Messages',
  'dashboard.goLive': 'Go Live',
  'dashboard.events': 'Events',

  // ─── Profile ───────────────────────────────────────────────────────────────
  'profile.myProfile': 'My Profile',
  'profile.personalInfo': 'Personal Information',
  'profile.skills': 'Skills',
  'profile.genres': 'Genres',
  'profile.portfolio': 'Portfolio',
  'profile.name': 'Name',
  'profile.bio': 'Bio',
  'profile.location': 'Location',
  'profile.website': 'Website',
  'profile.phone': 'Phone',
  'profile.avatar': 'Profile Picture',
  'profile.updateSuccess': 'Profile updated successfully',
  'profile.updateError': 'Failed to update profile',
  'profile.addSkill': 'Add Skill',
  'profile.addGenre': 'Add Genre',
  'profile.skillLevel': 'Skill Level',
  'profile.yearsExperience': 'Years of Experience',
  'profile.uploadTrack': 'Upload Track',
  'profile.trackTitle': 'Track Title',
  'profile.trackDescription': 'Description',
  'profile.profileUpdated': 'Profile updated',
  'profile.profileNotFound': 'Profile not found',
  'profile.myPortfolio': 'My Portfolio',
  'profile.myTracks': 'My Tracks',
  'profile.noTracksYet': 'No tracks uploaded yet',
  'profile.musicalSkills': 'Musical Skills',
  'profile.favoriteGenres': 'Favorite Genres',
  'profile.availability': 'Availability',
  'profile.availableForCollabs': 'Available for collaborations',
  'profile.availableForGigs': 'Available for gigs',
  'profile.editProfile': 'Edit Profile',
  'profile.tabs.personal': 'Personal',
  'profile.tabs.portfolio': 'Portfolio',
  'profile.tabs.skills': 'Skills',
  'profile.tabs.genres': 'Genres',
  'profile.tabs.availability': 'Availability',
  'profile.tabs.notifications': 'Notifications',
  'profile.bioPlaceholder': 'Tell us about yourself and your music...',
  'profile.locationPlaceholder': 'City, Country',
  'profile.websitePlaceholder': 'https://your-website.com',
  'profile.primaryInstrument': 'Primary Instrument',
  'profile.primaryGenre': 'Primary Genre',
  'profile.experienceYears': 'Years of Experience',
  'profile.artistName': 'Artist Name',
  'profile.changePhoto': 'Change Photo',
  'profile.uploadPhoto': 'Upload Photo',

  // ─── Matching ──────────────────────────────────────────────────────────────
  'matching.title': 'Musician Matching',
  'matching.subtitle': 'Find your ideal musical partner',
  'matching.aiTitle': 'AI-Powered Musician Matching',
  'matching.aiSubtitle': 'Intelligent matching system that analyzes compatibility across multiple dimensions',
  'matching.compatibility': 'Compatibility',
  'matching.sendRequest': 'Send Collaboration Request',
  'matching.viewProfile': 'View Profile',
  'matching.noMatches': 'No matches found',
  'matching.noMatchesHint': 'Try adjusting your filters',
  'matching.requestSent': 'Collaboration request sent!',
  'matching.requestError': 'Failed to send request',
  'matching.filters': 'Smart Filters',
  'matching.filtersSubtitle': 'Fine-tune your search with AI-powered filters',
  'matching.distance': 'Distance',
  'matching.minCompatibility': 'Compatibility Score',
  'matching.minMatch': 'Match Percentage',
  'matching.sortBy': 'Sort By',
  'matching.sortByMatch': 'Match Percentage',
  'matching.sortByCompatibility': 'Compatibility Score',
  'matching.availability': 'Availability',
  'matching.allMusicians': 'All Musicians',
  'matching.openForCollab': 'Open for Collaboration',
  'matching.availableForGigs': 'Available for Gigs',
  'matching.recalculate': 'Recalculate Matches',
  'matching.aiRecommended': 'AI Recommended',
  'matching.allMatches': 'All Matches',
  'matching.totalMatches': 'Total Matches',
  'matching.highCompatibility': 'High Compatibility',
  'matching.perfectMatches': 'Perfect Matches',
  'matching.complementarySkills': 'Complementary Skills',
  'matching.searchMusicians': 'Search Musicians',
  'matching.searchPlaceholder': 'Name or bio keywords...',
  'matching.locationFilter': 'Location',
  'matching.locationPlaceholder': 'City, state, or country...',
  'matching.suggestion.sharedTastes': 'Your shared musical tastes create an excellent foundation for collaboration.',
  'matching.suggestion.complementarySkills': 'Your complementary skills would create a well-rounded musical partnership.',
  'matching.suggestion.sameArea': 'Being in the same area makes in-person collaboration easy.',
  'matching.suggestion.strongPotential': 'You have strong potential for creative collaboration.',
  'matching.suggestion.differentPerspectives': 'Different perspectives could create unique musical opportunities.',

  // ─── Search ────────────────────────────────────────────────────────────────
  'search.title': 'Find Musicians',
  'search.subtitle': 'Discover talented musicians near you for collaboration',
  'search.placeholder': 'Search by name, instrument, or genre...',
  'search.results': 'Results',
  'search.noResults': 'No results found',
  'search.noResultsHint': 'Try adjusting your search filters',
  'search.filters': 'Filters',
  'search.instrument': 'Instrument',
  'search.genre': 'Genre',
  'search.location': 'Location',
  'search.availability': 'Availability',
  'search.mapView': 'Map View',
  'search.listView': 'List View',
  'search.savedSearches': 'Saved Searches',
  'search.saveSearch': 'Save Search',
  'search.saveSearchTitle': 'Save Search Preference',
  'search.saveSearchSubtitle': 'Save your current search filters to quickly access them later',
  'search.preferenceName': 'Preference Name',
  'search.preferenceNamePlaceholder': 'e.g., Jazz Musicians in Buenos Aires',
  'search.searchSaved': 'Search preference saved',
  'search.searchSaveError': 'Failed to save preference',
  'search.preferenceDeleted': 'Preference deleted',
  'search.preferenceDeleteError': 'Failed to delete preference',

  // ─── Projects ──────────────────────────────────────────────────────────────
  'projects.title': 'Projects',
  'projects.create': 'Create New Project',
  'projects.myProjects': 'My Projects',
  'projects.myApplications': 'My Applications',
  'projects.name': 'Project Name',
  'projects.description': 'Description',
  'projects.status': 'Status',
  'projects.budget': 'Budget',
  'projects.deadline': 'Deadline',
  'projects.roles': 'Roles Needed',
  'projects.addRole': 'Add Role',
  'projects.applications': 'Applications',
  'projects.timeline': 'Timeline',
  'projects.tasks': 'Tasks',
  'projects.createSuccess': 'Project created successfully',
  'projects.createError': 'Failed to create project',
  'projects.updateSuccess': 'Project updated successfully',
  'projects.deleteConfirm': 'Are you sure you want to delete this project?',
  'projects.deleteSuccess': 'Project deleted successfully',
  'projects.deleteError': 'Failed to delete project',
  'projects.members': 'Members',
  'projects.owner': 'Owner',
  'projects.updatedAt': 'Last Updated',
  'projects.invite': 'Invite',
  'projects.manage': 'Manage',
  'projects.noProjects': 'No projects found',
  'projects.noApplications': 'No applications found',
  'projects.filterAll': 'All',
  'projects.filterActive': 'Active',
  'projects.filterCompleted': 'Completed',
  'projects.filterArchived': 'Archived',
  'projects.statusRecruiting': 'Recruiting',
  'projects.statusInProgress': 'In Progress',
  'projects.statusPaused': 'Paused',
  'projects.statusCompleted': 'Completed',
  'projects.statusCancelled': 'Cancelled',
  'projects.applicationPending': 'Pending',
  'projects.applicationReviewing': 'Reviewing',
  'projects.applicationAccepted': 'Accepted',
  'projects.applicationRejected': 'Rejected',
  'projects.applicationWithdrawn': 'Withdrawn',
  'projects.appliedOn': 'Applied on',
  'projects.role': 'Role',
  'projects.withdraw': 'Withdraw',
  'projects.applyNow': 'Apply Now',
  'projects.viewDetails': 'View Details',
  'projects.resources': 'Resources',
  'projects.budget.title': 'Budget',
  'projects.noTasksYet': 'No tasks yet',
  'projects.addTask': 'Add Task',

  // ─── Marketplace ───────────────────────────────────────────────────────────
  'marketplace.title': 'Marketplace',
  'marketplace.subtitle': 'Find gigs, venues and opportunities',
  'marketplace.gigs': 'Gigs',
  'marketplace.venues': 'Venues',
  'marketplace.postGig': 'Post a Gig',
  'marketplace.createVenue': 'Add Venue',
  'marketplace.gigTitle': 'Gig Title',
  'marketplace.gigDescription': 'Description',
  'marketplace.gigDate': 'Date',
  'marketplace.gigLocation': 'Location',
  'marketplace.gigPay': 'Payment',
  'marketplace.applyToGig': 'Apply to Gig',
  'marketplace.applicationSent': 'Application sent successfully',
  'marketplace.applicationError': 'Failed to send application',
  'marketplace.noGigs': 'No gigs available',
  'marketplace.noVenues': 'No venues available',
  'marketplace.myGigs': 'My Gigs',
  'marketplace.myBookings': 'My Bookings',
  'marketplace.myVenues': 'My Venues',
  'marketplace.bookingStatus': 'Booking Status',
  'marketplace.bookingPending': 'Pending',
  'marketplace.bookingConfirmed': 'Confirmed',
  'marketplace.bookingCompleted': 'Completed',
  'marketplace.bookingCancelled': 'Cancelled',
  'marketplace.capacity': 'Capacity',
  'marketplace.genre': 'Genre',
  'marketplace.contactVenue': 'Contact Venue',
  'marketplace.viewVenue': 'View Venue',
  'marketplace.applyAs': 'Apply as',
  'marketplace.coverLetter': 'Cover Letter',
  'marketplace.gigType': 'Gig Type',

  // ─── Messages ──────────────────────────────────────────────────────────────
  'messages.title': 'Messages',
  'messages.conversations': 'Conversations',
  'messages.newMessage': 'New Message',
  'messages.typeMessage': 'Type a message...',
  'messages.noConversations': 'No conversations yet',
  'messages.noConversationsHint': 'Start a conversation from a musician\'s profile or project page.',
  'messages.sendError': 'Failed to send message',
  'messages.markAsRead': 'Mark as read',
  'messages.deleteConversation': 'Delete conversation',
  'messages.welcomeTitle': 'Welcome to Messages',
  'messages.welcomeSubtitle': 'Select a conversation from the list to start messaging, or start a new conversation from a musician\'s profile or project page.',
  'messages.noMessages': 'No messages yet',
  'messages.startConversation': 'Start the conversation!',
  'messages.someoneIsTyping': 'is typing...',
  'messages.loadingMessages': 'Loading messages...',
  'messages.sendMessage': 'Send',
  'messages.attachFile': 'Attach file',
  'messages.online': 'Online',
  'messages.offline': 'Offline',
  'messages.lastSeen': 'Last seen',
  'messages.loadingMore': 'Loading more...',
  'messages.loadMore': 'Load more messages',
  'messages.welcome': 'Welcome to Messages',
  'messages.selectConversation': 'Select a conversation from the list to start messaging, or start a new conversation from a musician\'s profile or project page.',
  'messages.micError': 'Could not access microphone',
  'messages.geoNotSupported': 'Geolocation is not supported',
  'messages.geoError': 'Could not get your location',
  'messages.voiceMessage': 'Voice message',

  // ─── Notifications ─────────────────────────────────────────────────────────
  'notifications.title': 'Notifications',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.noNotifications': 'No notifications',
  'notifications.settings': 'Notification Settings',
  'notifications.emailNotifications': 'Email Notifications',
  'notifications.pushNotifications': 'Push Notifications',
  'notifications.inAppNotifications': 'In-App Notifications',
  'notifications.doNotDisturb': 'Do Not Disturb',
  'notifications.enablePush': 'Enable Push Notifications',
  'notifications.disablePush': 'Disable Push Notifications',
  'notifications.permissionDenied': 'Push notification permission denied',
  'notifications.subscribeSuccess': 'Push notifications enabled',
  'notifications.unsubscribeSuccess': 'Push notifications disabled',
  'notifications.newMessage': 'New message',
  'notifications.collaborationRequest': 'Collaboration request',
  'notifications.projectUpdate': 'Project update',
  'notifications.gigApplication': 'Gig application',

  // ─── Index / Home ──────────────────────────────────────────────────────────
  'home.recentActivity': 'Recent Activity',
  'home.upcomingEvents': 'Upcoming Events',
  'home.nearbyMusicians': 'Nearby Musicians',
  'home.editProfile': 'Edit Profile',
  'home.findMusicians': 'Find Musicians',
  'home.goLive': 'Go Live',
  'home.events': 'Events',

  // ─── Public Portfolio / Musician Profile ───────────────────────────────────
  'musician.plays': 'plays',
  'musician.likes': 'likes',
  'musician.tracks': 'Tracks',
  'musician.playlists': 'Playlists',
  'musician.about': 'About',
  'musician.contact': 'Contact',
  'musician.sendMessage': 'Send Message',
  'musician.requestCollab': 'Request Collaboration',
  'musician.bpm': 'BPM',
  'musician.key': 'Key',
  'musician.duration': 'Duration',
  'musician.genre': 'Genre',
  'musician.instrument': 'Instrument',
  'musician.experience': 'Experience',
  'musician.location': 'Location',

  // ─── Track Detail ──────────────────────────────────────────────────────────
  'track.plays': 'plays',
  'track.uploadedOn': 'Uploaded on',
  'track.shareLink': 'Share link copied!',
  'track.comments': 'Comments',
  'track.addComment': 'Add a comment...',
  'track.technicalDetails': 'Technical Details',

  // ─── Onboarding ────────────────────────────────────────────────────────────
  'onboarding.title': 'Complete your profile',
  'onboarding.subtitle': 'Tell us about yourself to find the best musicians',
  'onboarding.step1.title': 'Your profile photo',
  'onboarding.step1.description': 'Upload a photo so other musicians can recognize you',
  'onboarding.step1.upload': 'Upload photo',
  'onboarding.step1.skip': 'Skip this step',
  'onboarding.step2.title': 'Your instruments',
  'onboarding.step2.description': 'Select the instruments you play (at least 1)',
  'onboarding.step3.title': 'Your music genres',
  'onboarding.step3.description': 'Choose the genres that identify you the most (at least 1)',
  'onboarding.step4.title': 'Your location',
  'onboarding.step4.description': 'Help us connect you with musicians near you',
  'onboarding.step4.city': 'City',
  'onboarding.step4.country': 'Country',
  'onboarding.next': 'Next',
  'onboarding.previous': 'Previous',
  'onboarding.finish': 'Finish',
  'onboarding.saving': 'Saving...',
  'onboarding.stepOf': 'Step {current} of {total}',

  // ─── CreateGig ───────────────────────────────────────────────────────────────
  'gig.create.title': 'Post new gig',
  'gig.create.description': 'Create an opportunity for musicians',
  'gig.form.venue': 'Venue',
  'gig.form.venue.placeholder': 'Select a venue',
  'gig.form.venue.empty': 'You need to create a venue first.',
  'gig.form.venue.create': 'Create venue',
  'gig.form.title': 'Gig title',
  'gig.form.title.placeholder': 'E.g., Jazz Night — Saturday',
  'gig.form.description': 'Description',
  'gig.form.description.placeholder': 'Describe the gig, expectations and what musicians need to know...',
  'gig.form.type': 'Gig type',
  'gig.form.type.placeholder': 'Select the type',
  'gig.form.date': 'Date and time',
  'gig.form.duration': 'Duration (hours)',
  'gig.form.budgetMin': 'Minimum budget ($)',
  'gig.form.budgetMax': 'Maximum budget ($)',
  'gig.form.genres': 'Genres',
  'gig.form.requirements': 'Requirements',
  'gig.form.requirements.placeholder': 'Equipment needed, experience level, dress code, etc.',
  'gig.form.submit': 'Post gig',
  'gig.form.submitting': 'Posting...',
  'gig.created.success': 'Gig posted successfully',
  // Gig validations
  'gig.validation.venue': 'Select a venue',
  'gig.validation.title.min': 'Minimum 3 characters',
  'gig.validation.title.max': 'Maximum 100 characters',
  'gig.validation.description.min': 'Minimum 20 characters',
  'gig.validation.description.max': 'Maximum 2000 characters',
  'gig.validation.type': 'Select the gig type',
  'gig.validation.date': 'Date is required',
  'gig.validation.date.future': 'Date must be in the future',
  'gig.validation.genres': 'Select at least one genre',
  'gig.validation.budget': 'Maximum budget must be ≥ minimum',
  // ─── CreateVenue ─────────────────────────────────────────────────────────────
  'venue.create.title': 'Create new venue',
  'venue.create.description': 'Add your venue to the marketplace',
  'venue.form.name': 'Venue name',
  'venue.form.name.placeholder': 'E.g., The Blue Note Club',
  'venue.form.description': 'Description',
  'venue.form.description.placeholder': 'Describe your venue, its atmosphere and what makes it special...',
  'venue.form.location': 'Location',
  'venue.form.location.placeholder': 'City, State/Country',
  'venue.form.capacity': 'Capacity',
  'venue.form.capacity.placeholder': 'E.g., 200',
  'venue.form.type': 'Venue type',
  'venue.form.type.placeholder': 'Select the type',
  'venue.form.email': 'Contact email',
  'venue.form.phone': 'Contact phone',
  'venue.form.phone.placeholder': '+54 9 11 1234-5678',
  'venue.form.website': 'Website',
  'venue.form.website.placeholder': 'https://yourvenue.com',
  'venue.form.imageUrl': 'Image URL',
  'venue.form.imageUrl.placeholder': 'https://example.com/image.jpg',
  'venue.form.submit': 'Create venue',
  'venue.form.submitting': 'Creating...',
  'venue.created.success': 'Venue created successfully',
  // Venue validations
  'venue.validation.name.min': 'Minimum 3 characters',
  'venue.validation.name.max': 'Maximum 100 characters',
  'venue.validation.location': 'Location is required',
  'venue.validation.type': 'Select the venue type',
  'venue.validation.email': 'Invalid email',
  'venue.validation.capacity': 'Must be a positive integer',
  'venue.validation.url': 'Invalid URL (must start with https://)',

  // ─── Errors ────────────────────────────────────────────────────────────────
  'error.pageNotFound': 'Page not found',
  'error.pageNotFoundHint': 'The page you are looking for does not exist.',
  'error.goHome': 'Go to home',
  'error.somethingWentWrong': 'Something went wrong',
  'error.tryAgain': 'Try again',
  'error.unknown': 'An unexpected error occurred',
  'error.network': 'Connection error. Please check your internet.',
  'error.timeout': 'The operation took too long. Please try again.',
  'error.duplicate': 'This record already exists.',
  'error.foreignKey': 'Related reference not found.',
  'error.invalidData': 'The provided data is invalid.',
  'error.notFound': 'The requested resource was not found.',
  'auth.emailNotConfirmed': 'Your email has not been confirmed yet. Check your inbox.',
  'auth.alreadyRegistered': 'This email is already registered.',

  // ─── Validation ────────────────────────────────────────────────────────────
  'validation.emailRequired': 'Email is required',
  'validation.emailInvalid': 'Invalid email address',
  'validation.passwordRequired': 'Password is required',
  'validation.passwordMinLength': 'Password must be at least 8 characters',
  'validation.confirmPasswordRequired': 'Password confirmation is required',
  'validation.displayNameRequired': 'Display name is required',
  'validation.displayNameMaxLength': 'Display name cannot exceed 50 characters',
  'validation.passwordsMustMatch': 'Passwords do not match',
  'validation.bioMaxLength': 'Bio cannot exceed 500 characters',
  'validation.cityMaxLength': 'City cannot exceed 100 characters',
  'validation.countryMaxLength': 'Country cannot exceed 100 characters',
  'validation.yearsExperienceMin': 'Years of experience cannot be negative',
  'validation.yearsExperienceMax': 'Years of experience cannot exceed 99',
  'validation.currentPasswordRequired': 'Current password is required',
  'validation.instrumentsRequired': 'Select at least one instrument',
  'validation.genresRequired': 'Select at least one genre',
  'validation.cityRequired': 'City is required',
  'validation.countryRequired': 'Country is required',
  'validation.projectNameRequired': 'Project name is required',
  'validation.projectNameMaxLength': 'Project name cannot exceed 100 characters',
  'validation.projectDescriptionRequired': 'Project description is required',
  'validation.projectDescriptionMaxLength': 'Description cannot exceed 2000 characters',
  'validation.locationMaxLength': 'Location cannot exceed 200 characters',
  'validation.objectivesMaxLength': 'Objectives cannot exceed 1000 characters',
  'validation.gigTitleRequired': 'Gig title is required',
  'validation.gigTitleMaxLength': 'Title cannot exceed 200 characters',
  'validation.gigDescriptionRequired': 'Gig description is required',
  'validation.gigDescriptionMaxLength': 'Description cannot exceed 2000 characters',
  'validation.gigTypeRequired': 'Gig type is required',
  'validation.gigDateRequired': 'Gig date is required',
  'validation.gigDurationMin': 'Minimum duration is 0.5 hours',
  'validation.gigDurationMax': 'Maximum duration is 24 hours',
  'validation.budgetMin': 'Minimum budget cannot be negative',
  'validation.budgetMax': 'Maximum budget cannot be negative',
  'validation.venueNameRequired': 'Venue name is required',
  'validation.venueNameMaxLength': 'Name cannot exceed 200 characters',
  'validation.venueDescriptionMaxLength': 'Description cannot exceed 2000 characters',
  'validation.venueLocationRequired': 'Venue location is required',
  'validation.venueLocationMaxLength': 'Location cannot exceed 200 characters',
  'validation.venueCapacityMin': 'Capacity must be at least 1',
  'validation.venueTypeRequired': 'Venue type is required',
};
